import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "el-footer"
};
import { ref } from 'vue';
import { ElMessage } from 'element-plus';

import axios from 'axios';
import { onMounted } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'UpdatePassword',
  props: {
    close: {
      type: Function
    }
  },
  setup(__props) {
    const props = __props;
    const loading = ref(false);
    const user = ref({
      phoneNumber: ''
    });
    const formData = ref({});
    const formRef = ref(null);
    const rules = {
      currentPassword: [{
        required: true,
        message: '请输入原密码',
        trigger: 'blur'
      }, {
        min: 6,
        max: 18,
        message: '密码长度应在 6 到 18 位之间',
        trigger: 'blur'
      }],
      newPassword: [{
        required: true,
        message: '请输入新密码',
        trigger: 'blur'
      }, {
        min: 6,
        max: 18,
        message: '密码长度应在 6 到 18 位之间',
        trigger: 'blur'
      }, {
        validator: (rule, value, callback) => {
          if (value === formData.value.currentPassword) {
            callback(new Error('新密码不能与原密码相同'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }],
      comfinPassword: [{
        required: true,
        message: '请再次输入新密码',
        trigger: 'blur'
      }, {
        validator: (rule, value, callback) => {
          if (value !== formData.value.newPassword) {
            callback(new Error('两次输入的新密码不一致'));
          } else {
            callback();
          }
        },
        trigger: 'blur'
      }]
    };
    const onSubmit = () => {
      formRef.value.validate(valid => {
        if (!valid) return;
        loading.value = true;
        axios.post(`/api/identity/Account/change-password`, formData.value).then(() => {
          props.close({});
          ElMessage.success('重置密码成功');
        }).finally(() => loading.value = false);
      });
    };
    const loadData = async () => {
      user.value = await axios.get(`/api/identity/Account/userinfo`);
    };
    onMounted(async () => {
      loadData();
    });
    return (_ctx, _cache) => {
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        "label-width": "120px",
        model: formData.value,
        rules: rules
      }, {
        default: _withCtx(() => [_createVNode(_component_el_form_item, {
          label: "账号"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(user.value.phoneNumber), 1)]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "原密码",
          prop: "currentPassword"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: formData.value.currentPassword,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => formData.value.currentPassword = $event),
            modelModifiers: {
              trim: true
            },
            maxlength: "18",
            placeholder: "密码长度不能低于6位"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "新密码",
          prop: "newPassword"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: formData.value.newPassword,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => formData.value.newPassword = $event),
            modelModifiers: {
              trim: true
            },
            maxlength: "18",
            placeholder: "密码长度不能低于6位"
          }, null, 8, ["modelValue"])]),
          _: 1
        }), _createVNode(_component_el_form_item, {
          label: "重复密码",
          prop: "comfinPassword"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: formData.value.comfinPassword,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => formData.value.comfinPassword = $event),
            modelModifiers: {
              trim: true
            },
            maxlength: "18",
            placeholder: "密码长度不能低于6位"
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model"]), _createElementVNode("div", _hoisted_1, [_createVNode(_component_el_button, {
        onClick: _cache[3] || (_cache[3] = $event => __props.close())
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("取消", -1)]))]),
        _: 1
      }), _createVNode(_component_el_button, {
        type: "primary",
        onClick: onSubmit,
        loading: loading.value
      }, {
        default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode(" 确 定 ", -1)]))]),
        _: 1
      }, 8, ["loading"])])]);
    };
  }
});